export default __webpack_public_path__ + "static/media/cases1.cd8203fe.webp";